import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from 'generated/graphql';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import CircleNumber from 'packages/kakapo-ui-kit/components/common/CircleNumber';
import EmptyStateCard from 'packages/kakapo-ui-kit/components/cards/EmptyStateCard';
import InboxTaskListEmptyState from 'packages/kakapo-ui-kit/assets/illustrations/InboxTaskListEmptyState';

import InboxTask from './InboxTask';
import InboxPersonalCard from './InboxPersonalCard';

export default function InboxTasksContainer() {
	const { t } = useTranslation();

	const { data, loading, refetch } = graphql.useInboxTasksQuery();

	const tasks = (data?.viewer.inboxTasks.slice() ?? []).reverse();

	return (
		<InboxPersonalCard>
			<Box padding={3}>
				<SectionTitle>
					<Flex flexDirection="row" alignItems="center">
						<span>{t('inbox.header.tasks')}</span>
						{tasks && tasks.length > 0 && (
							<Column ml={3}>
								<CircleNumber>{tasks.length}</CircleNumber>
							</Column>
						)}
					</Flex>
				</SectionTitle>
				<Column mt={3}>
					<Spinner isLoading={loading}>
						{tasks && tasks.length < 1 ? (
							<EmptyStateCard title={t('inbox.tasks.list.empty')} backgroundColor="white">
								<InboxTaskListEmptyState />
							</EmptyStateCard>
						) : (
							tasks?.map((task) => (
								<InboxTask key={task.id} task={task as graphql.InboxTask} refresh={refetch} />
							))
						)}
					</Spinner>
				</Column>
			</Box>
		</InboxPersonalCard>
	);
}
